'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function route(path, params) {
  if (params) {
    const segments = path.split(/\/+/).map((segment) => {
      if (segment.startsWith(":")) {
        const key = segment.replace(":", "").replace("?", "");
        if (key in params) {
          return params[key];
        }
        if (segment.endsWith("?")) {
          return null;
        }
      }
      return segment;
    });
    return segments.filter((value) => value != null).join("/");
  }
  return path;
}

exports.route = route;
//# sourceMappingURL=index.js.map
